
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { GetStaticPaths, GetStaticProps } from 'next';
import MarkyWebsiteUseCasePage from '@/components/marky/websites/MarkyWebsiteUseCasePage';
import { getMarkyWebsiteUseCase, MarkyWebsiteUseCase, markyWebsiteUseCases, } from '@/constants/markyWebsiteUseCases';
type MarkyWebsitePageProps = {
    useCase: MarkyWebsiteUseCase;
};
const MarkyWebsitePage = ({ useCase }: MarkyWebsitePageProps) => (<MarkyWebsiteUseCasePage useCase={useCase}/>);
export const getStaticPaths: GetStaticPaths = async ({ locales = ['en'] }) => ({
    paths: markyWebsiteUseCases.flatMap((useCase) => locales.map((locale) => ({
        params: { slug: useCase.slug },
        locale,
    }))),
    fallback: false,
});
const getStaticProps: GetStaticProps<MarkyWebsitePageProps> = async ({ params, }) => {
    const slug = Array.isArray(params?.slug) ? params?.slug[0] : params?.slug;
    const useCase = slug ? getMarkyWebsiteUseCase(slug) : undefined;
    if (!useCase) {
        return { notFound: true };
    }
    return {
        props: { useCase },
    };
};
export default MarkyWebsitePage;

    async function __Next_Translate__getStaticProps__1a13a29a0fa__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/marky/website-builder/[slug]',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a13a29a0fa__ as getStaticProps }
  